/** @jsx jsx */
import React, { Component } from "react";
import algoliasearch from "algoliasearch/lite";
import {
    InstantSearch,
    SearchBox,
    connectStats,
    Pagination,
    connectStateResults,
    connectHits,
    HitsPerPage,
    connectCurrentRefinements,
    Configure,
    connectSortBy
} from "react-instantsearch-dom";
import { enquireScreen } from "enquire-js";
import { jsx, Box, Flex, Text, Grid, Button, Spinner, Select } from "theme-ui";
import queryString from "query-string";
import CardView from "./CardView";
import CompletenessView from "./completeness";
import RefList from "./refList";
import DataSource from "./DataSource";
import SortComp from "./SortComp";
import Icon from "../Icon";

let queryParams = '';
if (typeof window !== "undefined") {
    window.expectationsFilter = [];
    window.isSubFilterEquals = true;
    queryParams = window.location.search ? queryString.parse(window.location.search) : '';
}
const searchClient = algoliasearch(
    "2S9KBQSQ3L",
    "1aeb416dedd122b926b314c930f51dc0"
);

const refinements = ({ items, refine }) => (
    <Text sx={{
        cursor: "pointer",
        fontFamily: "Open Sans"
    }} onClick={() => refine(items)} disabled={!items.length}>
        Clear filters
    </Text>
);

const CustomClearRefinements = connectCurrentRefinements(refinements);

const Hits = ({
    hits,
    viewType,
    mobileView,
    packageName,
    filters,
    version
}) =>(() => {
    if (viewType === "Summary") return <CardView dataset={hits} screenSize={mobileView} packageName={packageName} filters={filters} version={version} />;
    if (viewType === "Completeness") return <CompletenessView dataset={hits} filters={filters} />;
    if (viewType === "Datasource") return <DataSource dataset={hits} filters={filters} />;
    return null;
})();

const CountComponent = ({ nbHits }) => <Text> {nbHits} Total</Text>;
const HitsCount = connectStats(CountComponent);

const removeAllURLParameters = () => {
    let url = '';
    if (typeof window !== "undefined") {
        const url = new URL(window.location.href);
    }

    url.search = ''; // Remove all query parameters
    window.history.pushState(null, '', url.pathname + url.search);
};


const StateResults = ({ searching }) => {
    if (searching) {
        return (
            <Flex sx={{
                justifyContent: "center",
            }}>
                <Spinner variant="styles.spinner" />
            </Flex>
        );
    }
    return null;
};

const CustomStateResults = connectStateResults(StateResults);

const CustomHits = connectHits(Hits);

const CustomSortBy = connectSortBy(SortComp);

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewType: "Summary",
            showFilters: false,
            filterType: "Backend support",
            gotoPage: 1,
            isMobile: false,
            filters: {
                subFilterValues: []
            }
        };
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        if (queryParams && queryParams.subFilterValues) {
            const subFilter = queryParams.subFilterValues ? queryParams.subFilterValues.split(",") : [];
            this.setState({
                viewType: queryParams.viewType,
                showFilters: queryParams.showFilters === "true",
                filterType: queryParams.filterType,
                gotoPage: queryParams.gotoPage,
                filters: {
                    subFilterValues: subFilter
                }
            });
        }
        else {
            this.setState({
                viewType: "Summary",
                showFilters: true,
                filterType: "Backend support",
                gotoPage: 1,
                isMobile: false,
                filters: {
                    subFilterValues: []
                }
            });
            window.expectationsFilter = [];
            window.isSubFilterEquals = true;
        }
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        queryParams = '';
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleResize = () => {
        const { isMobile } = this.state;
        let resize = false;
        enquireScreen(b => {
            resize = b;
        });
        this.setState({ isMobile: resize });
        if (isMobile) {
            this.setState({ viewType: 'Summary' });
        }
    };


    setDefaultPage = (pageNumber) => {
        this.setState({ gotoPage: pageNumber });
    };

    handleClearFIlters = () => {
        window.expectationsFilter = [];
        removeAllURLParameters();   
        this.setState({
            filterType: "Backend support",
            filters: {
                subFilterValues: []
            }
        });
    };

    changeView(view) {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        urlParams.set("viewType", view);
        url.search = urlParams.toString();
        window.history.pushState(null, '', url.pathname + url.search);
        this.setState({ viewType: view });
    }

    toggleFilter() {
        const { showFilters } = this.state;
        if (showFilters) {
            this.handleClearFIlters();
        }
        this.setState({
            showFilters: !showFilters,
            gotoPage: 1
        });
    }

    render() {
        const { index, packageName, sortingList, sortingIndex, version } = this.props;
        const { viewType, isMobile, showFilters, filterType, gotoPage, filters } = this.state;
        return (
            <Box
                sx={{
                    marginTop: "80px",
                    border: "1px solid #D9D9D9",
                    borderRadius: "8px 8px 0px 0px",
                }}
            >
                <InstantSearch
                    indexName={index}
                    searchClient={searchClient}
                >
                    {packageName &&
                        <Configure
                            facetFilters={[`package:${packageName}`]}
                            hitsPerPage={2}
                        />
                    }
                    {isMobile ?
                        <Flex
                            sx={{
                                backgroundColor: "#FFFFFF",
                                borderBottom: "1px solid #D9D9D9",
                                borderRadius: "8px 8px 0px 0px",
                                padding: "16px",
                                flexDirection:'column !important',
                                gap: "16px",
                            }}
                            className="expec-search-component"
                        >
                            <Box>
                                <Text sx={{ fontSize: "16px", fontWeight: "600" }}>
                                    Expectations: &nbsp;&nbsp;
                                </Text>
                                <HitsCount />
                            </Box>
                            <Box
                                sx={{
                                    width: ["280px"],
                                    marginTop: "10px",
                                    height: "32px",
                                }}
                                className="expec-search-div"
                            >
                                <SearchBox
                                    className="expec-list-search"
                                    sx={{ height: "30px" }}
                                />
                            </Box>
                        </Flex> :
                        <Flex
                            sx={{
                                alignItems: "center",
                                backgroundColor: "#FFFFFF",
                                borderBottom: "1px solid #D9D9D9",
                                borderRadius: "8px 8px 0px 0px",
                                padding: "16px",
                                gap: "16px",
                            }}
                            className="expec-search-component"
                        >
                            <Box className="expec-search-count">
                                <Text sx={{ fontSize: ["12px", "12px", "12px", "12px", "16px"], fontWeight: "600" }}>
                                    Expectations: &nbsp;&nbsp;
                                </Text>
                                <HitsCount />
                            </Box>
                            <Box
                                sx={{
                                    flexGrow:1,
                                    height: "32px",
                                }}
                                className="expec-search-div"
                            >
                                <SearchBox
                                    className="expec-list-search"
                                    sx={{ height: "30px", width: "100%" }}
                                />
                            </Box>
                            <Flex>
                                <CustomSortBy items={sortingList} sortingIndex={sortingIndex} />
                            </Flex>

                            {/* <Flex
                                sx={{
                                    p: "4px 4px",
                                    cursor: "pointer",
                                    border: "1px solid #D9D9D9",
                                    borderRadius: "4px",
                                    gap: "4px",
                                    width:"100px",
                                }}
                                className="expec-filter"
                                onClick={() => this.toggleFilter()}
                            >
                                <Box > Filter by</Box>
                                <StaticImage
                                    src="../../../images/vector.svg"
                                    style={{
                                        marginTop: "5px",
                                        height: "14px",
                                        width: "14px",
                                    }}
                                    alt="filter"
                                />
                            </Flex> */}
                            <Flex sx={{ border: "1px solid #D9D9D9", borderRadius: "4px" }} className="summary-tabs">
                                <Box
                                    sx={{ p: "4px 16px", cursor: "pointer" }}
                                    onClick={() => this.changeView("Summary")}
                                    className={viewType === "Summary" ? "highlight tab" : "tab"}
                                >
                                    Summary
                                </Box>
                                <Box
                                    sx={{ p: "4px 16px", cursor: "pointer" }}
                                    onClick={() => this.changeView("Completeness")}
                                    className={
                                        viewType === "Completeness" ? "highlight tab" : "tab"
                                    }
                                >
                                    Completeness
                                </Box>
                                {/* commented as datasource view not yet available */}
                                <Box
                                    sx={{ p: "4px 16px", cursor: "pointer" }}
                                    onClick={() => this.changeView("Datasource")}
                                    className={
                                        viewType === "Datasource" ? "highlight tab" : "tab"
                                    }
                                >
                                    Datasource
                                </Box>
                            </Flex>
                        </Flex>}

                    {!isMobile && showFilters && (
                        <Box sx={{ p: "20px" }}>
                            <Flex
                                sx={{
                                    justifyContent: "space-between",
                                    borderBottom: "1px solid lightgrey",
                                }}
                            >
                                <Flex sx={{ display: "none", gap: "20px" }}>
                                    <Button className="expec-filter-button selected">
                                        Basic
                                    </Button>
                                    <Button className="expec-filter-button">Advanced</Button>
                                </Flex>
                                <CustomClearRefinements />
                            </Flex>

                            <Grid
                                columns={[2, null, 6]}
                                sx={{ alignItems: "center", height: "32px", pt: "10px" }}
                            >
                                <Text sx={{ fontSize: "14px", fontWeight: "600" }}>
                                    Filter by:
                                </Text>
                                <Select
                                    arrow={
                                        <Box sx={{
                                            ml: -28,
                                            alignSelf: "center",
                                            pointerEvents: "none"
                                        }}>
                                            <Icon icon='md-arrow-down' />
                                        </Box>
                                    }
                                    sx={{
                                        border: "1px solid #D9D9D9",
                                        height: "32px",
                                        fontSize: "14px",
                                        p: "5px",
                                        background: "#FFFFFF",
                                        outline: "none",
                                        cursor: "pointer",
                                        fontFamily: "Open Sans"
                                    }}

                                    value={filterType}
                                    onChange={(e) => {
                                        this.handleClearFIlters()
                                        this.setState({
                                            filterType: e.target.value,
                                            gotoPage: 1,
                                            filters: {
                                                subFilterValues: []
                                            }
                                        })}
                                    }
                                >
                                    <option>Backend support</option>
                                    {/* <option>Tags</option> */}
                                    <option>Expectation Class</option>
                                    <option>Package</option>
                                    <option>Metrics</option>
                                    <option>Contributors</option>
                                </Select>

                                {/* {filterType === "Tags" && (
                                    <div className="expec-multi-select">
                                        <RefList viewType={viewType} filterType={"Tags"} attribute="library_metadata.tags" searchable={false} onFilterSelectedValue={filters.subFilterValues} />
                                    </div>
                                )} */}
                                {filterType === "Backend support" && (
                                    <div className="expec-multi-select">
                                        <RefList viewType={viewType} filterType={"Backend support"} attribute="engineSupported" searchable={false} onFilterSelectedValue={filters.subFilterValues} />
                                    </div>

                                )}
                                {filterType === "Expectation Class" && (
                                    <div className="expec-multi-select">
                                        <RefList viewType={viewType} filterType={"Expectation Class"} attribute="exp_type" searchable={false} onFilterSelectedValue={filters.subFilterValues} />
                                    </div>
                                )}
                                {filterType === "Package" && (
                                    <div className="expec-multi-select">
                                        <RefList viewType={viewType} filterType={"Package"} attribute="package" searchable={false} onFilterSelectedValue={filters.subFilterValues} />
                                    </div>
                                )}
                                {filterType === "Metrics" && (
                                    <div className="expec-multi-select">
                                        <RefList viewType={viewType} filterType={"Metrics"} attribute="metrics" searchable={false} onFilterSelectedValue={filters.subFilterValues} />
                                    </div>
                                )}
                                {filterType === "Contributors" && (
                                    <div className="expec-multi-select">
                                        <RefList viewType={viewType} filterType={"Contributors"} attribute="contributors" searchable={false} onFilterSelectedValue={filters.subFilterValues} />
                                    </div>
                                )}
                            </Grid>
                        </Box>
                    )}
                    <CustomStateResults />
                    <CustomHits
                        viewType={viewType}
                        mobileView={isMobile}
                        packageName={packageName}
                        filters={ { viewType, showFilters, filterType, gotoPage, filters }}
                        version={version}
                    />
                    <Flex className="expec-pagination-row">
                        <Pagination
                            className="expec-pagination"
                            showFirst={false}
                            padding={2}
                            defaultRefinement={gotoPage}
                        />
                        {!isMobile &&
                            <Flex sx={{ alignItems: "center", gap: "8px" }}>
                                <HitsPerPage defaultRefinement={15}
                                    items={[
                                        { value: 15, label: '15 / Page' },
                                        { value: 30, label: '30 / Page' },
                                        { value: 45, label: '45 / Page' },
                                    ]}
                                />
                            </Flex>
                        }
                    </Flex>
                </InstantSearch>
            </Box>
        );
    }
}

export default Search;
